import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAnalysisGroup5 } from '../../entities/control-tables/product-analysis-group5-entity';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class ProductAnalysisGroup5Request extends BaseRequest {

    productAnalysisGroup5 : ProductAnalysisGroup5
    
  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productAnalysisGroup5 = new ProductAnalysisGroup5()
  }
}